import React, { useState } from "react";
import { toast } from "sonner";
import { Lightning } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { slotLabel, useBusyAlerts } from "@/lib/useBusyAlerts";

const Slots = ({ data }) => (
  <div className="mt-3 flex flex-wrap gap-2" data-testid="busy-alerts-slots">
    {data.slots.length ? data.slots.map((s, i) => (
      <span key={`${s.day}-${s.hour}`} className="border-2 border-black px-2 py-1 text-xs" data-testid={`busy-alerts-slot-${i}`}>
        <b>{slotLabel(s)}</b> · {s.sold} sold
      </span>
    )) : (
      <span className="text-xs text-zinc-500" data-testid="busy-alerts-none">
        No busy times yet. A time needs {data.min_sold} or more sold leads in the last 4 weeks.
      </span>
    )}
  </div>
);

export const BusyAlertsCard = () => {
  const { data, setData } = useBusyAlerts(true);
  const [busy, setBusy] = useState(false);
  if (!data) return null;
  const flip = async () => {
    setBusy(true);
    try {
      const r = await api.put("/media-buyer/busy-alerts", { enabled: !data.enabled });
      setData({ ...data, enabled: r.data.enabled });
      toast.success(r.data.enabled ? "Busy-hour alerts turned on" : "Busy-hour alerts turned off");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't save");
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="brut-card bg-white p-3 mb-6" data-testid="busy-alerts-card">
      <div className="flex flex-wrap items-center gap-3">
        <Lightning size={18} weight="bold" />
        <div className="flex-1 min-w-[220px]">
          <div className="font-chivo font-black uppercase text-sm tracking-tight">Busy-hour alerts</div>
          <div className="text-xs text-zinc-600">An email and a notice here about an hour before your top 3 selling times (last 4 weeks, Eastern).</div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Switch checked={data.enabled} onCheckedChange={flip} disabled={busy} data-testid="busy-alerts-toggle" />
          <span className="label-mono w-8" data-testid="busy-alerts-status">{data.enabled ? "On" : "Off"}</span>
        </div>
      </div>
      <Slots data={data} />
    </section>
  );
};
